import { render } from "./SelectProducts.vue?vue&type=template&id=ddec0f66&scoped=true&ts=true"
import script from "./SelectProducts.vue?vue&type=script&lang=ts"
export * from "./SelectProducts.vue?vue&type=script&lang=ts"

import "./SelectProducts.vue?vue&type=style&index=0&id=ddec0f66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddec0f66"]])

export default __exports__